import * as React from 'react';

import { CombinedPackageViewProps } from '../../components/list/package';
import ListPerformances from '../../components/list/performances';

const ListPackageView: React.StatelessComponent<CombinedPackageViewProps> = props => {

    const selectSubscriptionButton = (
        <button className="btn" onClick={() => {
            props.selectedPackage ?
                props.removeFromCart(props.package.id)
                : props.selectPackage(props.package, props.useUnseatedReserve);
        }}>
            {props.selectedPackage ? props.text.removeButtonText : props.text.selectSubscriptionButtonText}
        </button>
    );

    return (
        <li key={props.package.id} data-package-id={props.package.id}>
            <article>
                <div className="ace-subs-package-header">
                    <div className="ace-subs-package-details">
                        <div className="rich-text stack-xs">
                            <h3 className="h1-secondary">
                                {props.package.title}
                            </h3>
                            {
                                props.package.description ?
                                    <p className="small">{props.package.description}</p>
                                    : null
                            }
                        </div>
                        <div className="rich-text stack-xs">
                            {
                                props.package.packageTimeDescriptionMessage ?
                                    <p className="h3-secondary">{props.package.packageTimeDescriptionMessage}</p>
                                    : null
                            }
                            {
                                props.package.numberOfPerformancesMessage ?
                                    <p className="small">{props.package.numberOfPerformancesMessage}</p>
                                    : null
                            }
                        </div>
                    </div>

                    {  //check to see if there is only one package (then it doesn't make sense to be able to remove it)
                        props.numberOfPackagesInList == 1 && props.selectedPackage && props.useUnseatedReserve
                            ? null
                            :
                            <div className="ace-subs-package-select ace-hide-for-tablet">
                                {selectSubscriptionButton}
                            </div>
                    }
                </div>
                {props.settings.voucherPackage ? null :
                    <div className="stack space-top">
                        <button className="un-button primary-link dropdown-trigger dropdown-trigger-down"
                            onClick={props.toggleShowPerformances}>
                            {
                                props.showPerformances ? props.text.hidePerformancesButtonText
                                    : props.text.viewPerformancesButtonText
                            }
                        </button>

                        <div className={props.showPerformances ? "show" : "hide"}>
                            <ListPerformances filteredPerformances={props.packagePerformances} />
                        </div>
                        <div className="ace-show-for-tablet space-top-lg">
                            {selectSubscriptionButton}
                        </div>
                    </div>
                }
            </article>
        </li>
    )
}

export default ListPackageView;